import { render, staticRenderFns } from "./room_give_rule_set.vue?vue&type=template&id=34d47711&scoped=true"
import script from "./room_give_rule_set.vue?vue&type=script&lang=js"
export * from "./room_give_rule_set.vue?vue&type=script&lang=js"
import style0 from "./room_give_rule_set.vue?vue&type=style&index=0&id=34d47711&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d47711",
  null
  
)

export default component.exports